import api from "./api";
import TokenService from "./token.service";
import { clearActingTenant } from "src/Common/tenant";
import { clearVocabulary } from "src/Common/vocab";
import PermissionService from "./permission.service";

const register = (name, email, password) => {
  return api.post("/api/auth/register", {
    name,
    email,
    password,
  });
};

const login = (email, password) => {
  return api.post(
    "/api/auth/login",
    {
      email,
      password,
    },
    { withCredentials: true }
  );
};

const logout = () => {
  TokenService.removeUser();
  TokenService.removeAccessToken();
  PermissionService.clearPermissions();
  clearActingTenant();
  // The next user may be in another company, which has its own wording.
  clearVocabulary();
};

const AuthService = {
  register,
  login,
  logout,
};

export default AuthService;
